import { createContext, Dispatch, SetStateAction, useState } from "react";

export interface IAppContext {
  companyStage: string;
  setCompanyStage: Dispatch<SetStateAction<string>>;
  companyIndustry: string;
  setCompanyIndustry: Dispatch<SetStateAction<string>>;
  founderGender: string;
  setFounderGender: Dispatch<SetStateAction<string>>;
  founderRace: string;
  setFounderRace: Dispatch<SetStateAction<string>>;
  mailingAddress: string;
  setMailingAddress: Dispatch<SetStateAction<string>>;
}

export const AppContext = createContext<IAppContext>({} as IAppContext);

export const AppContextProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [companyStage, setCompanyStage] = useState("");
  const [companyIndustry, setCompanyIndustry] = useState("");
  const [founderGender, setFounderGender] = useState("");
  const [founderRace, setFounderRace] = useState("");
  const [mailingAddress, setMailingAddress] = useState("");

  return (
    <AppContext.Provider
      value={{
        companyStage,
        companyIndustry,
        setCompanyStage,
        setCompanyIndustry,
        founderGender,
        setFounderGender,
        founderRace,
        setFounderRace,
        mailingAddress,
        setMailingAddress,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
